import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCountry: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
  },
});

export const { setSelectedCountry } = contactSlice.actions;
export const selectSelectedCountry = (state) => state.contact.selectedCountry;

export default contactSlice.reducer;
